// extracted by mini-css-extract-plugin
export default {"ProfileMenu":"style_ProfileMenu__xuQoz"};